import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import useStyles from "./styles";
import KM_Icon from "../../icons/KM_LOGO.svg";
import apple_store from "../../icons/apple_store.svg";
import g_playStore from "../../icons/g_play.svg";

export default function DesktopHeader() {
  const classes = useStyles();
  return (
    <>
      <header className={clsx(classes.header)}>
        <div className={clsx(classes.flex, classes.alignCenter)}>
          <Link to="/">
            <img className={classes.kmLogo} src={KM_Icon} alt="KM-logo" />
          </Link>
        </div>
        <div
          className={clsx(classes.headBox, classes.flex, classes.alignCenter)}
        >
          {/* <div className={clsx(classes.flex, classes.storeBox)}>
						<a className={clsx(classes.appleStore)} href="https://apps.apple.com/in/app/khelomore-book-sports-venues/id1536558207"> <img src={apple_store} alt="apple-store" /> </a>
						<a className={clsx(classes.googleStore, classes.appleStore)} href="https://play.google.com/store/apps/details?id=com.khelomore.pnp&hl=en_IN&gl=US"> <img src={g_playStore} alt="googlePlay-store" /> </a>
					</div> */}
          <h1>
            <a
              href="https://khelomore.com/sports-venues"
              className={clsx(classes.venue, classes.marginLeft)}
            >
              SPORTS VENUES
            </a>
          </h1>
          <a
            href="https://khelomore.com/sports-coaching/?category=at_home"
            className={clsx(classes.venue, classes.marginLeft)}
          >
            COACHING
          </a>
          <a
            href="https://www.khelomore.com/sports-coaching/one-on-one-personal-training"
            className={clsx(classes.venue, classes.marginLeft)}
          >
            <span>PERSONAL TRAINING</span>
            {/* <span className={clsx(classes.newTag)}>New</span> */}
          </a>
          <a
            href="https://www.khelomore.com/events/explore-events"
            className={clsx(classes.venue, classes.marginLeft)}
          >
            EVENTS
          </a>
          <a
            href="https://shop.khelomore.com/"
            className={clsx(classes.venue, classes.marginLeft)}
          >
            SHOP
          </a>
          <div className={clsx(classes.flex, classes.textBox)}>
            {/* <a href="#" className={clsx(classes.account, classes.venue)}>My Account</a> */}
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeHRjh5iIz-zS-iCeB1S8kPuosccr6MWV0ByZx4IAJ3nCfOVg/viewform"
              className={clsx(classes.venue, classes.registerCTA)}
            >
              Register Your Venue
            </a>
          </div>
        </div>
      </header>
    </>
  );
}
